import React from 'react'
import styled from 'styled-components'

/**
 * 问卷 - 题目设置特殊配置区域容器
 *
 * @param param - 参数
 * @param param.title - 标题
 * @param param.component - React.ReactNode
 * @param param.isProductSetting - 是否是复合组件的配置
 * @returns React.ReactNode
 */
export const BaseSpeacialSettingWrapper: React.FC<{
  title: string | React.ReactNode
  component: React.ReactNode
  isProductSetting?: boolean
}> = ({ title, component, isProductSetting }) => {
  return (
    <SpeacialSettingWrapper
      style={{ padding: isProductSetting ? '16px 8px' : '16px 20px' }}
    >
      <Title>{title}</Title>
      {component}
    </SpeacialSettingWrapper>
  )
}

const SpeacialSettingWrapper = styled.div`
  box-shadow: inset 0px -1px 0px 0px #e5e6e8;
  &&& {
    .ant-input-number-focused {
      border-color: ${(props) => props.theme.brand._1};
    }
    .ant-select-focused .ant-select-selector {
      border-color: ${(props) => props.theme.brand._1} !important;
    }
  }
`

const Title = styled.div`
  width: 100%;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.text._2};
`
